// tslint:disable
/**
 * Course API
 * Used for: - Manage courses - Manage course info - Manage students - Learning control 
 *
 * The version of the OpenAPI document: 2.6.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as globalImportUrl from 'url';
import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';

import { LearningProgress } from '../models';
import { Progress } from '../models';
/**
 * LearningProgressApi - axios parameter creator
 * @export
 */
export const LearningProgressApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        finishCourseRegistration(id: string, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling finishCourseRegistration.');
            }
            const localVarPath = `/course-registration/{id}/finish`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-API-TOKEN")
                    : configuration.apiKey;
                localVarHeaderParameter["X-API-TOKEN"] = localVarApiKeyValue;
            }

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {Array<'sessions'>} [fields] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLearningProgress(id: string, fields?: Array<'sessions'>, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling getLearningProgress.');
            }
            const localVarPath = `/course-registration/{id}/learning-progress`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-API-TOKEN")
                    : configuration.apiKey;
                localVarHeaderParameter["X-API-TOKEN"] = localVarApiKeyValue;
            }

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (fields) {
                localVarQueryParameter['fields'] = fields.join(COLLECTION_FORMATS.csv);
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {Array<string>} [lessonIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProgress(id: string, lessonIds?: Array<string>, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling getProgress.');
            }
            const localVarPath = `/course-registration/{id}/progress`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-API-TOKEN")
                    : configuration.apiKey;
                localVarHeaderParameter["X-API-TOKEN"] = localVarApiKeyValue;
            }

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (lessonIds) {
                localVarQueryParameter['lessonIds'] = lessonIds.join(COLLECTION_FORMATS.csv);
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LearningProgressApi - functional programming interface
 * @export
 */
export const LearningProgressApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        finishCourseRegistration(id: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void> {
            const localVarAxiosArgs = LearningProgressApiAxiosParamCreator(configuration).finishCourseRegistration(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {Array<'sessions'>} [fields] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLearningProgress(id: string, fields?: Array<'sessions'>, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<LearningProgress> {
            const localVarAxiosArgs = LearningProgressApiAxiosParamCreator(configuration).getLearningProgress(id, fields, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {Array<string>} [lessonIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProgress(id: string, lessonIds?: Array<string>, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Progress> {
            const localVarAxiosArgs = LearningProgressApiAxiosParamCreator(configuration).getProgress(id, lessonIds, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * LearningProgressApi - factory interface
 * @export
 */
export const LearningProgressApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        finishCourseRegistration(id: string, options?: any) {
            return LearningProgressApiFp(configuration).finishCourseRegistration(id, options)(axios, basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {Array<'sessions'>} [fields] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLearningProgress(id: string, fields?: Array<'sessions'>, options?: any) {
            return LearningProgressApiFp(configuration).getLearningProgress(id, fields, options)(axios, basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {Array<string>} [lessonIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProgress(id: string, lessonIds?: Array<string>, options?: any) {
            return LearningProgressApiFp(configuration).getProgress(id, lessonIds, options)(axios, basePath);
        },
    };
};

/**
 * LearningProgressApi - object-oriented interface
 * @export
 * @class LearningProgressApi
 * @extends {BaseAPI}
 */
export class LearningProgressApi extends BaseAPI {
    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LearningProgressApi
     */
    public finishCourseRegistration(id: string, options?: any) {
        return LearningProgressApiFp(this.configuration).finishCourseRegistration(id, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {string} id 
     * @param {Array<'sessions'>} [fields] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LearningProgressApi
     */
    public getLearningProgress(id: string, fields?: Array<'sessions'>, options?: any) {
        return LearningProgressApiFp(this.configuration).getLearningProgress(id, fields, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @param {string} id 
     * @param {Array<string>} [lessonIds] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LearningProgressApi
     */
    public getProgress(id: string, lessonIds?: Array<string>, options?: any) {
        return LearningProgressApiFp(this.configuration).getProgress(id, lessonIds, options)(this.axios, this.basePath);
    }

}
